// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var _map = {"sha1":"SHA-1","sha256":"SHA-256","sha384":"SHA-384","sha512":"SHA-512"};

var _revMap = {"SHA-1":"sha1","SHA-256":"sha256","SHA-384":"sha384","SHA-512":"sha512"};

function algorithmToJs(param) {
  return _map[param];
}

function algorithmFromJs(param) {
  return _revMap[param];
}

var Digest = {
  algorithmToJs: algorithmToJs,
  algorithmFromJs: algorithmFromJs
};

function digest(algorithm, arrayBuffer) {
  return crypto.subtle.digest(_map[algorithm], arrayBuffer);
}

exports.Digest = Digest;
exports.digest = digest;
/* No side effect */
